import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=6e5e5cf1&scoped=true&"
import script from "./Package.vue?vue&type=script&lang=js&"
export * from "./Package.vue?vue&type=script&lang=js&"
import style0 from "./Package.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Package.vue?vue&type=style&index=1&id=6e5e5cf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5e5cf1",
  null
  
)

export default component.exports